export default __webpack_public_path__ + "static/media/max_list.5f0beb2b.svg";